import { Outlet } from "react-router-dom";

import { Skeleton } from "~/components/kiosk/products/skeleton";
import { ModalErrorGeneric } from "~/components/kiosk/ui/modals/error/modal-error-generic";
import { kioskActions } from "~/stores/kiosk-session/actions";
import { useKioskProducts } from "~/stores/kiosk-session/hooks/use-kiosk-products";

import { KioskProductsPage } from "./kiosk-products-page/kiosk-products-page";

export const KioskProductsRoute = () => {
  const { status: productsStatus } = useKioskProducts();

  if (productsStatus === "pending") {
    return <Skeleton />;
  }

  if (productsStatus === "error") {
    return (
      <ModalErrorGeneric
        onClose={() => {
          kioskActions.session.reset();
        }}
      />
    );
  }

  return (
    <>
      <KioskProductsPage />

      <Outlet />
    </>
  );
};
